// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LLcJ","name":"Header_name__3ce3R","birthday":"Header_birthday__1ZY0c","skeleton":"Header_skeleton__3QJfG"};